import { TemplateRef } from '@angular/core';
import {
  CellTemplateContext,
  ColumnBuilder,
  DatasetTableConfig,
  formattedColumn,
  TableConfigBuilder,
  textColumn,
} from '@ui';
import { OrgWallEntry } from '../../store/state/org-walls/org-walls.models';

export type OrgWallCellContext = CellTemplateContext<OrgWallEntry>;

export interface CreateOrgWallsTableConfigDependencies {
  templates: {
    typeCell: TemplateRef<OrgWallCellContext>;
  };
  onRowClick: (wall: OrgWallEntry) => void;
}

export function createOrgWallsTableConfig(
  dependencies: CreateOrgWallsTableConfigDependencies,
): DatasetTableConfig<OrgWallEntry> {
  const builder = new ColumnBuilder<OrgWallEntry>();

  return new TableConfigBuilder<OrgWallEntry>()
    .columns([
      textColumn<OrgWallEntry>('name', 'WALLS_LIST.TABLE.WALL_NAME', {
        width: 'minmax(140px, 1.2fr)',
        mobileVisible: true,
      }),
      builder
        .column('isPrivate')
        .label('WALLS_LIST.TABLE.TYPE')
        .width('minmax(80px, 0.8fr)')
        .cellTemplate(dependencies.templates.typeCell)
        .alignCenter()
        .build(),
      textColumn<OrgWallEntry>(
        'organizationName',
        'WALLS_LIST.TABLE.ORGANIZATION',
        {
          width: 'minmax(128px, 1.1fr)',
          mobileVisible: true,
        },
      ),
      textColumn<OrgWallEntry>('accountName', 'WALLS_LIST.TABLE.ACCOUNT', {
        width: 'minmax(128px, 1.1fr)',
        mobileVisible: true,
      }),
      formattedColumn<OrgWallEntry>(
        'tilesCount',
        'WALLS_LIST.TABLE.TILES',
        (_, row) => row.tilesCount,
        {
          width: 'minmax(80px, 0.6fr)',
          mobileVisible: true,
          alignCenter: true,
          cardIcon: 'ui-icon-apps',
        },
      ),
    ])
    .onRowClick((row) => dependencies.onRowClick(row))
    .trackBy('id')
    .build();
}
